import React from 'react'
import { Editor } from '@tiptap/react'
import { color } from '@trivie/ui-web/theme'

import {
  AddPhotoAlternate,
  AutoAwesome,
  AutoMode,
  FormatBold,
  FormatItalic,
  FormatListBulleted,
  FormatListNumbered,
  FormatUnderlined,
  Numbers,
  Subscript as SubscriptIcon,
  Superscript as SuperscriptIcon,
} from '@mui/icons-material'
import { IconButton, ListItemIcon, Menu, MenuItem, Stack } from '@mui/material'

import { Text } from '@trivie/ui-web/components/text'
import { Divider } from '@trivie/ui-web/components/divider'
interface DocumentToolbarProps {
  editor: Editor | null
  handleAddMedia?: any
}
export const DocumentToolbar = (props: DocumentToolbarProps) => {
  const { editor, handleAddMedia } = props

  const iconStyle = { height: 28, width: 28 }

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const openHeader = Boolean(anchorEl)
  const handleClickHeader = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const closeHeader = () => setAnchorEl(null)

  return (
    <>
      <Menu
        open={openHeader}
        onClose={closeHeader}
        anchorEl={anchorEl}
        sx={{
          '& .MuiPaper-root': {
            borderRadius: '6px !important',
            border: `1px solid #EFF0F6`,
            padding: 0,
            // boxShadow: 'none',
          },
        }}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      >
        <MenuItem
          sx={{ minHeight: 32 }}
          onClick={() => {
            editor?.chain().focus().clearNodes().run()
            closeHeader()
          }}
        >
          <Text
            style={{
              fontWeight: 400,
              fontSize: 14,
              lineHeight: '17px',
            }}
            text="Normal Text"
          />
        </MenuItem>
        <Divider />
        <MenuItem
          sx={{ minHeight: 32 }}
          onClick={() => {
            editor?.chain().focus().unsetAllMarks().run()
            editor?.chain().focus().setHeading({ level: 1 }).run()
            closeHeader()
          }}
        >
          <Text
            style={{
              fontWeight: 700,
              fontSize: 24,
              lineHeight: '24px',
            }}
            text="Heading 1"
          />
        </MenuItem>
        <MenuItem
          sx={{ minHeight: 32 }}
          onClick={() => {
            editor?.chain().focus().unsetAllMarks().run()
            editor?.chain().focus().setHeading({ level: 2 }).run()
            closeHeader()
          }}
        >
          <Text
            style={{
              fontWeight: 700,
              fontSize: 20,
              lineHeight: '20px',
            }}
            variant="labelEmphasized"
            text="Heading 2"
          />
        </MenuItem>
        <MenuItem
          sx={{ minHeight: 32 }}
          onClick={() => {
            editor?.chain().focus().unsetAllMarks().run()
            editor?.chain().focus().setHeading({ level: 3 }).run()
            closeHeader()
          }}
        >
          <Text
            style={{
              fontWeight: 700,
              fontSize: 18,
              lineHeight: '18px',
            }}
            variant="titleEmphasized"
            text="Heading 3"
          />
        </MenuItem>
      </Menu>
      <Stack
        position="absolute"
        top={0}
        flex={0}
        width="100%"
        direction="row"
        useFlexGap
        gap={1}
        style={CONTAINER}
      >
        <IconButton onClick={() => editor?.chain().focus().toggleBold().run()} style={iconStyle}>
          <FormatBold
            fontSize="small"
            htmlColor={editor?.isActive('bold') ? color.blue : color.shade70}
          />
        </IconButton>
        <IconButton onClick={() => editor?.chain().focus().toggleItalic().run()} style={iconStyle}>
          <FormatItalic
            fontSize="small"
            htmlColor={editor?.isActive('italic') ? color.blue : color.shade70}
          />
        </IconButton>
        <IconButton
          onClick={() => editor?.chain().focus().toggleUnderline().run()}
          style={iconStyle}
        >
          <FormatUnderlined
            fontSize="small"
            htmlColor={editor?.isActive('underline') ? color.blue : color.shade70}
          />
        </IconButton>
        <IconButton onClick={handleClickHeader} style={iconStyle}>
          <Numbers
            fontSize="small"
            htmlColor={editor?.isActive('heading') ? color.blue : color.shade70}
          />
        </IconButton>
        <IconButton
          onClick={() => editor?.chain().focus().toggleOrderedList().run()}
          style={iconStyle}
        >
          <FormatListNumbered
            fontSize="small"
            htmlColor={editor?.isActive('orderedList') ? color.blue : color.shade70}
          />
        </IconButton>
        <IconButton
          onClick={() => editor?.chain().focus().toggleBulletList().run()}
          style={iconStyle}
        >
          <FormatListBulleted
            fontSize="small"
            htmlColor={editor?.isActive('bulletList') ? color.blue : color.shade70}
          />
        </IconButton>
        {/* <IconButton
          onClick={() => editor?.chain().focus().toggleSubscript().run()}
          style={iconStyle}
        >
          <SubscriptIcon
            fontSize="small"
            htmlColor={editor?.isActive('subscript') ? color.blue : color.shade70}
          />
        </IconButton>
        <IconButton
          onClick={() => editor?.chain().focus().toggleSuperscript().run()}
          style={iconStyle}
        >
          <SuperscriptIcon
            fontSize="small"
            htmlColor={editor?.isActive('superscript') ? color.blue : color.shade70}
          />
        </IconButton> */}
        {Boolean(handleAddMedia) && (
          <IconButton onClick={handleAddMedia} style={iconStyle}>
            <AddPhotoAlternate fontSize="small" htmlColor={color.shade70} />
          </IconButton>
        )}
      </Stack>
    </>
  )
}

const CONTAINER: React.CSSProperties = {
  flex: 0,
  padding: 8,
  left: 0,
  height: 40,
  alignItems: 'center',
  borderBottom: `1px solid #EFF0F6`,
}
